import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Bigfixtemplate extends Component {
 
  render() {
    const course =[
      {
       title : "Introduction to BigFix",
        content: [
        "What is BigFix",
        "History of BigFix",
        "BigFix architecture",
        "BigFix components",
        "BigFix console"
        ]
        },
        {
       title : "BigFix Deployment",
        content: [
        "BigFix deployment architecture",
        "BigFix deployment planning",
        "BigFix installation and configuration",
        "BigFix agent deployment",
        "BigFix license management"
        ]
        },
        {
       title : "BigFix Administration",
        content: [
        "BigFix console administration",
        "BigFix server administration",
        "BigFix client administration",
        "BigFix policy administration",
        "BigFix patch management"
        ]
        },
        {
       title : "BigFix Relevance Language",
        content: [
        "Introduction to BigFix relevance language",
        "Relevance expressions",
        "Relevance clauses",
        "Relevance substitution",
        "Relevance debugging"
        ]
        },
        {
       title : "BigFix Action Language",
        content: [
        "Introduction to BigFix action language",
        "Action script expressions",
        "Action clauses",
        "Action substitution",
        "Action debugging"
        ]
        },
        {
       title : "BigFix Web Reports",
        content: [
        "Introduction to BigFix Web Reports",
        "Web Reports architecture",
        "Web Reports installation and configuration",
        "Web Reports customization",
        "Web Reports troubleshooting"
        ]
        },
        {
       title : "BigFix REST API",
        content: [
        "Introduction to BigFix REST API",
        "REST API architecture",
        "REST API endpoints",
        "REST API methods",
        "REST API authentication"
        ]
        },
        {
       title : "BigFix Integration",
        content: [
        "BigFix integration with third-party tools",
        "BigFix integration with ServiceNow",
        "BigFix integration with IBM Tivoli",
        "BigFix integration with Chef",
        "BigFix integration with Ansible"
        ]
        }
    ]

    const faqData = [
      {
        question: 'What is BigFix Training?',
        answer:
          'BigFix Training is a specialized program designed to educate individuals on how to effectively manage and secure endpoints using the BigFix platform',
      },
      {
        question: 'Why is BigFix Training important?',
        answer:
          'BigFix Training is essential for IT professionals to learn how to streamline endpoint management, ensure compliance, and enhance security posture across their organization',
      },
      {
        question: 'What topics are covered in BigFix Training?',
        answer:
        "BigFix Training at the best training centre covers a wide range of topics, including BigFix architecture, deployment, patch management, software distribution, compliance reporting, and troubleshooting",
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with BigFix skills can pursue a variety of career opportunities such as Endpoint Engineer, IT Security Analyst, Network Administrator, and IT Operations Manager',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a journey to master BigFix at the Best Training Centre. Our comprehensive BigFix training program welcomes learners from all backgrounds, irrespective of prior experience in endpoint management. Whether you're an IT professional seeking to enhance your skills or someone entirely new to BigFix, our courses cater to individuals at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential BigFix concepts, including installation, configuration, patch management, compliance, and security. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in managing endpoints with BigFix. Join us and unlock your potential in BigFix with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
    return(
      <>
    
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="BigFix is a suite of products that provides a fast and intuitive solution for compliance, endpoint, and security management and allows organizations to see and manage physical and virtual endpoints through a single infrastructure, a single console, and a single type of agent.
                The BigFix agent checks the registry, systems language, and other factors to determine if the patches are not installed or if an installed patch is corrupt."/> */}
            <NewMainsec rating='4.2' students={"390"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1}  intro='DataOps is a collaborative approach to data management that emphasizes communication, integration, and automation across data-related processes. It seeks to improve the quality and availability of data for analytics and other business applications. The term "DataOps" is a combination of "data" and "operations," and it draws inspiration from DevOps principles.'/>
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Our BigFix Training program in ${this.props.location} is designed to provide you with a comprehensive understanding of BigFix, an endpoint management solution. In this training program, you will learn about the architecture of BigFix, how to configure and deploy agents, how to manage patches, and how to monitor endpoints. You will also learn how to automate endpoint management tasks using BigFix, including software distribution, compliance reporting, and more.`} 
              title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our BigFix course covers a wide range of topics, including patch management, endpoint management, software distribution, and compliance management. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in BigFix. By the end of the course, you will be able to implement BigFix practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1}  cou="Okta" coupath="okta" cou1='Endpoint Manager' coupath1='endpoint-manager' cou2='Jira' coupath2='jira-admin' cou3='Kanban' coupath3='kanban' 
          cou4='Tenable' coupath4='tenable' cou5='ServiceNow' coupath5='servicenow' cou6='SAP' coupath6='sap' cou7='Scrum Master' coupath7='scrum-master' cou8='ITSM' coupath8='itsm' cou9='Dynamic365' coupath9='dynamic365'  cou10='Pega' coupath10='pega'/>
        
      </>
    );
  }
}
